// Used in assignment-info-dialog.component.html and tiles.component.html

// Angular
import { Component, Input, OnInit } from "@angular/core";
// Types
import { Perform } from "@carnegie-learning/cure-types";
import { PPAssignment as Assignment } from "cli-types";

@Component({
    selector: "performance-directions",
    templateUrl: "./performance-directions.component.html",
    styleUrls: [
        "./performance-directions.component.scss",
        "../../../styles/shared-styles.scss",
    ],
    standalone: false
})
export class PerformanceDirectionsComponent implements OnInit {
    @Input() fontSize: string;
    @Input() maxAttempts: string;
    @Input() assignment: Assignment;
    @Input() asset: Perform;

    constructor() {}

    ngOnInit(): void {}

    formatMaxAttempts(maxAttempts: number) {
        if (maxAttempts === -1) {
            return " as many times as you want";
        } else if (maxAttempts === 1) {
            return " up to " + maxAttempts + " time";
        } else {
            return " up to " + maxAttempts + " times";
        }
    }
}
